<div class="page-container pb-5">
  <h1 class="title --page">
    Mentions Légales
  </h1>
  <h2 class="subtitle --center">Reelax Tickets</h2>

  <h3 class="fs-20 mt-5">L’entreprise :</h3>
  <p class="text">
    REELAX TICKETS
    <br>
      SAS au capital social de 53 000€
      <br>
        La société a été créee le 22/07/2019 et immatriculée au Régime du Commerce et des sociétés de Rennes sous le numéro 852 723 063
        <br><br>
        Le siège social de REELAX TICKETS est situé au : 21 rue Jean Marie Duhamel 35000 RENNES
        <br>
          L’adresse mail de contact est : <a class="link --primary" href="mailto:contact@reelax-tickets.com">contact&#64;reelax-tickets.com</a>
          <br>
            Le directeur de la publication est : Maxime LIGNEL
            <br>
              Le délégué à la protection des données est : Kévin PASTOR
              <br><br>
              L’éditeur consent à l’utilisateur le droit de consultation du site <a class="link --primary" href="https://reelax-tickets.com/" target="_blank">https://reelax-tickets.com/</a>
              (et des sous domaines associés) pour son usage strictement personnel et privé.
              Toute reproduction, rediffusion ou commercialisation totale ou partielle du contenu est interdite.
            </p>

            <h3 class="fs-20 mt-5">Hébergement :</h3>
            <p class="text">
              Ce site est hébergé par OVH – 2 rue Kellermann – 59100 ROUBAIX – France.
              Immatriculée sous le RCS de Lille Métropole sous le numéro 424 761 419
              <br>
                Pour contacter cet hébergeur, rendez-vous à l’adresse <a class="link --primary" href="https://www.ovh.com/fr/support/" target="_blank" rel="noopener">https://www.ovh.com/fr/support/</a>
              </p>

              <h3 class="fs-20 mt-5">Protection des données :</h3>
              <p class="text">
                Vous pouvez trouver toutes les informations relatives à la protection des données de nos utilisateurs à l'adresse :
                <a class="link --primary" target="_blank" href="https://reelax-tickets.com/assets/pdf/PP_reelax.pdf">https://reelax-tickets.com/assets/pdf/PP_reelax.pdf</a>
              </p>
              <p class="text mb-0">Statistiques d'utilisation du site avec
                <a class="link --primary" href="https://matomo.org" target="_blank">
                  Matomo (privacy by design)
                </a> :
              </p>
              @for (url of matomoIframeUrl; track url) {
                <iframe
                  style="border: 0; height: inherit; width: inherit;"
                  [src]="url"
                ></iframe>
              }

            </div>
